import React from 'react';
import { Tooltip } from '@material-ui/core';
import { FlashOn, PublicOutlined, StorefrontOutlined } from '@material-ui/icons';
import { RoutingChip, RoutingGroup, ShopIconWrap } from './blocks';
import { ROUTING_CHIPS } from './constants';
import { routingModeFor, shipperTypeForRouting, ROUTING_SHOP } from './utils';

const CHIP_TITLES = {
    AUTO: 'Auto Assign — route by consignee zip',
    SHOP: 'Rate Shop — pre-assigned carrier pricing',
    MARKETPLACE: 'Marketplace — open to carrier bids',
};

// Auto and Shop take their glyphs from the Figma. Marketplace has no chip in the design, so
// the globe is our pick — revisit if the chip survives past the next sprint.
const CHIP_ICONS = {
    AUTO: <FlashOn />,
    MARKETPLACE: <PublicOutlined />,
};

const RoutingToggle = ({ client, onChange, disabled }) => {
    const active = routingModeFor(client?.shipper_type);

    return (
        <RoutingGroup>
            {ROUTING_CHIPS.map(({ mode, label }) => {
                const selected = active === mode;
                return (
                    <Tooltip key={mode} title={CHIP_TITLES[mode]} placement="top">
                        {/* span so the Tooltip still works while the chip is disabled */}
                        <span>
                            <RoutingChip
                                type="button"
                                selected={selected}
                                disabled={disabled}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (disabled || selected) return;
                                    onChange(shipperTypeForRouting(mode));
                                }}
                            >
                                {mode === ROUTING_SHOP ? (
                                    <ShopIconWrap selected={selected}>
                                        <StorefrontOutlined />
                                    </ShopIconWrap>
                                ) : (
                                    CHIP_ICONS[mode]
                                )}
                                {label}
                            </RoutingChip>
                        </span>
                    </Tooltip>
                );
            })}
        </RoutingGroup>
    );
};

export default RoutingToggle;
